import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dispatch, GET_DATA_USERS, roles, RootState } from "shared";
import { fieldsFormUserTfe } from "../helper/fieldsFormUsersTfe";
import { columnsGridUsersTfe } from "../helper/columnsGridUsersTfe";
import { columnsUsersTfeType } from "../types/columsUsersTfe.types";
import { IconButton, Tooltip } from "@mui/material";
import { AddUsersTfe } from "../components/AddUsersTfe";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import { postData } from "shared/api/services/postdata";
import { deleteData } from "shared/api/services/deleteData";
import { putData } from "shared/api/services/putData";
import Swal from "sweetalert2";

export const useUsersTfe = () => {
  const dispatch = useDispatch<Dispatch>();
  const { content, paramsUrl } = useSelector(
    (state: RootState) => state.electronicDocuments,
  );
  const { loading } = useSelector(
    (rootState: RootState) => rootState.loading.models.linkDocument,
  );
  const { userRoles } = useSelector(
    (state: RootState) => state.optionsDropdowns,
  );
  const [dataFields, setDataFields] = useState<any[]>([]);
  const [columns, setColumns] = useState<any[]>([]);
  const [showForm, setShowForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const valuesResultsPages = [50, 100, 250, 500];

  const toogleShowForm = () => setShowForm((prev) => !prev);

  const onCloseModal = () => {
    dispatch.messageModal.cleanStateMessage();
    dispatch.electronicDocuments.getElectronicDocuments(
      paramsUrl,
      `${GET_DATA_USERS}/users-roles/`,
    );
  };

  const AddUsers = (values?: any) => {
    dispatch.messageModal.setMessageModal({
      show: true,
      title: `Agregar usuarios`,
      onClose() {
        onCloseModal();
      },
      size: "large",
      description: <AddUsersTfe />,
    });
  };

  const buildUrl = (valuesUrl: any) => {
    const url = `${GET_DATA_USERS}/users-roles/`;
    const params = {
      page: 1,
      size: 50,
      name: valuesUrl.name.trim(),
      mail: valuesUrl.email.trim(),
    };
    return { params, url };
  };

  const { handleChange, handleSubmit, values, resetForm } = useFormik({
    initialValues: {
      name: "",
      email: "",
    },
    onSubmit: (vls) => {
      const result = buildUrl(vls);
      dispatch.electronicDocuments.getElectronicDocuments(
        result.params,
        result.url,
      );
    },
    validateOnChange: false,
    enableReinitialize: true,
  });

  const getValue = (name: string) => {
    const valueField: any = Object.entries(values).find(
      ([key, value]) => key === name,
    );
    return valueField[1];
  };

  const handleRoleAssignment = async (
    rolId: any,
    userId?: number,
    params?: any,
  ) => {
    setIsLoading(true);
    await putData(`${GET_DATA_USERS}/${params.userId}`, {
      oldRolId: params.rolId,
      newRolId: rolId.id,
      rolName: rolId.backendName,
    })
      .then(() => {
        dispatch.electronicDocuments.getElectronicDocuments(
          paramsUrl,
          `${GET_DATA_USERS}/users-roles/`,
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const deleteRoleAssignment = async (params?: any) => {
    Swal.fire({
      title: "Confirmar",
      text: "¿Estás seguro que quieres remover el usuario?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        await deleteData(
          `${GET_DATA_USERS}/${params.userId}/roles/${params.rolId}`,
        )
          .then(() => {
            dispatch.electronicDocuments.getElectronicDocuments(
              paramsUrl,
              `${GET_DATA_USERS}/users-roles/`,
            );
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    });
  };

  useEffect(() => {
    setDataFields(fieldsFormUserTfe());
  }, []);

  const getDataUsers = () => {
    dispatch.electronicDocuments.getElectronicDocuments(
      { page: 1, size: 50 },
      `${GET_DATA_USERS}/users-roles/`,
    );
    resetForm();
  };

  useEffect(() => {
    dispatch.menuDrawer.changeSelectedIndex(6);

    return () => {
      dispatch.electronicDocuments.cleanState();
    };
  }, []);

  useEffect(() => {
    const columnsTransform: any[] = [
      ...columnsGridUsersTfe(userRoles, handleRoleAssignment),
      {
        field: "actions",
        headerName: "",
        minWidth: 70,
        renderCell(params: columnsUsersTfeType) {
          return (
            params.rolName && (
              <Tooltip title={"Remover permiso"} placement="top" arrow>
                <IconButton
                  aria-label="update"
                  data-testid="update-glosa"
                  onClick={() => deleteRoleAssignment(params)}
                >
                  <DisabledByDefaultIcon fontSize="small" color="info" />
                </IconButton>
              </Tooltip>
            )
          );
        },
      },
    ];
    setColumns(columnsTransform);
  }, [content, userRoles]);

  useEffect(() => {
    if (userRoles.length === 0) {
      dispatch.optionsDropdowns.getUserRoles();
    }
  }, [userRoles?.length == 0]);

  return {
    showForm,
    columns,
    valuesResultsPages,
    isLoading,
    loading,
    dataFields,
    handleChange,
    handleSubmit,
    getValue,
    handleRoleAssignment,
    toogleShowForm,
    AddUsers,
    getDataUsers,
  };
};
